<template>
  <div class="brand-list">
    <ul class="brand-item" v-for="item in list" :key="item.id">
      <li class="icon">
        <img :src="item.img" :alt="item.slug" />
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'brandList',
  props: {
    list: [Array]
  }
}
</script>

<style scoped lang="scss">
//brand-list
.brand-list {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -10px;
  .brand-item {
    flex: 0 0 calc(10% - 20px);
    margin: 0 10px 20px;
    .icon {
      display: block;
      padding-top: 100%;
      position: relative;
      overflow: hidden;
      border-radius: 50%;
      background: $white2;
      img {
        position: absolute;
        top: 50%;
        left: 50%;
        -webkit-transform: translate(-50%, -50%);
        -moz-transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        width: 48px;
      }
    }
  }
}
@media only screen and (max-width: 767px) {
  .brand-list .brand-item {
    flex: 0 0 calc(25% - 20px);
  }
}
</style>
